// extracted by mini-css-extract-plugin
module.exports = {"popupWrapper":"style_popupWrapper__2Gj_l","infoContent":"style_infoContent__1uvmN","title":"style_title__3p1rl","content":"style_content__36iIw"};